import type { FC } from 'react';
import { NodeViewWrapper } from '@tiptap/react';
import type { NodeViewProps } from '@tiptap/react';

import type { CommentMentionTarget } from '@/types';

import CommentMentionTag from '../CommentMentionTag';

type CommentMentionNodeViewProps = Pick<NodeViewProps, 'node'> & {
    hoverable?: boolean;
    interactive?: boolean;
    publicMemoId?: string;
    publicWorkspaceMetadata?: boolean;
};

const CommentMentionNodeView: FC<CommentMentionNodeViewProps> = ({
    hoverable,
    interactive,
    node,
    publicMemoId,
    publicWorkspaceMetadata,
}) => (
    <NodeViewWrapper
        as='span'
        contentEditable={false}
        data-comment-mention-node='true'
        data-workspace-mention-node='true'
        style={{ alignItems: 'center', display: 'inline-flex', lineHeight: '1.5rem', verticalAlign: 'middle' }}
    >
        <CommentMentionTag
            hoverable={hoverable}
            interactive={interactive}
            mention={node.attrs as CommentMentionTarget}
            publicMemoId={publicMemoId}
            publicWorkspaceMetadata={publicWorkspaceMetadata}
        />
    </NodeViewWrapper>
);

export default CommentMentionNodeView;
